<div class="service-legalese" data-testid="service-legalese">
  <puro-typography component="p" variant="body2" class="service-legalese__guarantees">
    <span class="service-legalese__asterisk" aria-hidden="true">*</span
    ><button
      type="button"
      class="service-legalese__guarantees-link"
      data-testid="service-guarantees-link"
      [attr.aria-label]="
        'createShipment.serviceStep.deliveryService.legalese.openGuaranteesAria' | translate
      "
      (click)="openGuaranteesDialog()"
    >
      {{
        'createShipment.serviceStep.deliveryService.legalese.serviceGuarantees' | translate
      }}</button
    ><span class="service-legalese__middle">{{
      'createShipment.serviceStep.deliveryService.legalese.areSubjectTo' | translate
    }}</span
    ><span class="service-legalese__terms">{{
      'createShipment.serviceStep.deliveryService.legalese.termsOfService' | translate
    }}</span
    ><span class="service-legalese__end">{{
      'createShipment.serviceStep.deliveryService.legalese.sentenceEnd' | translate
    }}</span>
  </puro-typography>
  <puro-typography component="p" variant="body2" class="service-legalese__note">
    {{ 'createShipment.serviceStep.deliveryService.legalese.costNote' | translate }}
  </puro-typography>
</div>

<app-service-guarantees-dialog [open]="guaranteesDialogOpen()" (closed)="closeGuaranteesDialog()" />
